import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) setVisible(true);
  }, []);

  const choose = (choice) => {
    localStorage.setItem("cookie_consent", JSON.stringify({ choice, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-slate-900 text-white rounded-xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 border border-slate-700">
        <Cookie className="w-6 h-6 text-blue-400 shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-bold">Vi använder cookies</p>
          <p className="text-xs text-slate-300 mt-1 leading-relaxed">
            Redoc QMS använder nödvändiga cookies för inloggning och säkerhet — ingen spårning eller marknadsföring.
            Läs mer i vår <Link to="/cookies" className="underline text-blue-300 hover:text-blue-200">cookiepolicy</Link> och{" "}
            <Link to="/integritet" className="underline text-blue-300 hover:text-blue-200">integritetspolicy</Link>.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            data-testid="cookie-essential-btn" onClick={() => choose("essential")}
            className="text-xs font-semibold px-3.5 py-2 rounded-lg bg-slate-700 hover:bg-slate-600 transition-colors"
          >
            Endast nödvändiga
          </button>
          <button
            data-testid="cookie-accept-all-btn" onClick={() => choose("all")}
            className="text-xs font-bold px-3.5 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 transition-colors"
          >
            Acceptera alla
          </button>
        </div>
      </div>
    </div>
  );
}
